<div class="toast-container">
  @for(toast of toastService.toastQueue(); track toast.id) {
  <div @slideInOut 
       class="toast" 
       [class]="toast.type"
       role="status"
       [attr.aria-live]="toast.type === 'error' ? 'assertive' : 'polite'"
       [attr.aria-atomic]="true"
       [attr.aria-label]="toast.type === 'success' ? 'Success notification' : 'Error notification'"
       [attr.aria-describedby]="'toast-message-' + toast.id"
       tabindex="-1"
       #toastElement> 
    <div class="content">
      <cwo-icon class="icon" [name]="getIconName(toast.type)" aria-hidden="true" />
      <span class="message" [id]="'toast-message-' + toast.id">
        {{ toast.message }}
      </span>
    </div>
    <button class="button close-button" 
            (click)="onClose(toast.id)"
            (keydown.enter)="onClose(toast.id)"
            (keydown.space)="onClose(toast.id); $event.preventDefault()"
            [attr.aria-label]="'Close notification: ' + toast.message"
            [attr.aria-label]="'Close ' + toast.type + ' notification'"
            [attr.aria-describedby]="'toast-message-' + toast.id"
            #closeButton>
      <cwo-icon [name]="IconNameType.close" class="icon" aria-hidden="true" />
    </button>
  </div>
  }
</div>